import { useSearch } from "wouter";
import { Seo } from "@/components/Seo";
import { Section, PageHeader } from "@/components/Section";
import { LegalProse } from "@/components/LegalProse";
import {
  CURRENT_LEGAL_VERSION,
  getLegalVersion,
  listLegalVersions,
} from "./versions";

export default function Dpa() {
  const search = useSearch();
  const requested = new URLSearchParams(search).get("v");
  const { entry, isCurrent, isKnown } = getLegalVersion(requested);
  const Body = entry.Dpa;
  const path = isCurrent ? "/legal/dpa" : `/legal/dpa?v=${entry.version}`;
  const lede = isCurrent
    ? `Last updated ${entry.lastUpdatedLabel}. This Data Processing Agreement forms part of the Terms of Service between FortifyID and your organisation.`
    : `Archived version published ${entry.lastUpdatedLabel}. This is a historical copy preserved for workspaces that accepted this version. The current DPA is at /legal/dpa.`;

  return (
    <>
      <Seo
        title={
          isCurrent
            ? "Data Processing Agreement"
            : `Data Processing Agreement (${entry.version})`
        }
        description="The Data Processing Agreement that applies between FortifyID and your organisation."
        path={path}
      />
      <Section>
        <PageHeader
          eyebrow={
            isCurrent
              ? "Legal · Data Processing Agreement"
              : `Legal · Data Processing Agreement · Archived ${entry.version}`
          }
          title="Data Processing Agreement"
          lede={lede}
        />
        <LegalProse>
          {requested && !isKnown ? (
            <p>
              <em>
                The DPA version <code>{requested}</code> is not in our archive.
                Showing the current version ({CURRENT_LEGAL_VERSION}) instead.
              </em>
            </p>
          ) : null}
          <Body />
          <hr />
          <p className="text-sm">
            <strong>Version archive.</strong> Every published version of this
            DPA is preserved here so any workspace that accepted an earlier
            copy can review the exact wording it agreed to:
          </p>
          <ul className="text-sm">
            {listLegalVersions().map((v) => (
              <li key={v.version}>
                <a href={`/legal/dpa?v=${v.version}`}>
                  {v.version} — published {v.lastUpdatedLabel}
                </a>
                {v.version === CURRENT_LEGAL_VERSION ? " (current)" : null}
              </li>
            ))}
          </ul>
        </LegalProse>
      </Section>
    </>
  );
}
